import React from 'react';
import './Notifications.css';

const NotificationItem = ({ message, isNew }) => {
  const formatTimestamp = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return date.toLocaleDateString();
  };

  return (
    <div className={`notification-item ${isNew ? 'notification-item--new' : ''}`}>
      <span className="notification-icon">
        {message.userPhoto ? (
          <img src={message.userPhoto} alt={message.username} className="notification-user-photo" />
        ) : (
          '💬'
        )}
      </span>
      <div className="notification-content">
        <div className='notification-summary'>
          <strong>{message.username}</strong>
          {message.organisation && (
            <span className="notification-org-badge">{message.organisation}</span>
          )}
          {isNew && <span className="notification-new-badge">NEW</span>}
          <div className='notification-text'>{message.text}</div>
        </div>
        <div className='notification-time'>
          {formatTimestamp(message.createdAt)}
        </div>
      </div>
    </div>
  );
};

export default NotificationItem;
